// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__2fxXg","title":"AfterImages90_title__398nm","images":"AfterImages90_images__6UbEr"};